import { Component, Input, OnChanges } from '@angular/core';
import { KraMetricResult, metricResultStatuses } from '../../../../models/kraMetricModels';

@Component({ selector: 'app-criterion-metric-evidence', templateUrl: './criterion-metric-evidence.component.html', standalone: false })
export class CriterionMetricEvidenceComponent implements OnChanges {
  @Input() evidence: KraMetricResult[] = [];
  @Input() kraID: number;
  @Input() measurableID: number;
  @Input() kpiID: number;
  @Input() categoryID: number;
  @Input() saved = false;
  @Input() reviewDate: Date;
  matches: KraMetricResult[] = [];
  statuses = metricResultStatuses;
  operators = ['>', '>=', '<', '<=', '=', 'between'];

  ngOnChanges() {
    this.matches = (this.evidence || []).filter(x => x.result.components?.length > 0 && x.result.kraid === this.kraID && x.result.measurableID === this.measurableID
      && (x.result.kpiid ?? null) === (this.kpiID ?? null) && (x.result.categoryID ?? null) === (this.categoryID ?? null));
  }
  lastDate(end: string) {
    if (!end) return null;
    const date = new Date(end); date.setDate(date.getDate() - 1); return date;
  }
}
